import { createContext } from 'react'

import { WorkspaceBidderContextType } from './types'

export const WorkspaceBidderContext = createContext<WorkspaceBidderContextType>(
  {} as WorkspaceBidderContextType,
)
